/* globals $, globalScene, allTweens, controller */
import { TimelineMax, Strong } from 'gsap';
import 'gsap/ScrollToPlugin';

import calculateOffset from 'helpers/calculateOffset';
import ScrollMagic from 'helpers/importers/ScrollMagic';

export default function teamScene () {
  let tweenTeam = new TimelineMax()
  .from('#meet-team > .wrapper h2', 0.5, {
    xPercent: -120,
    opacity: 0,
    ease: Strong.easeOut,
  })
  .from('#meet-team > .wrapper .view-team-members', 0.8, {
    yPercent: 120,
    opacity: 0,
    ease: Strong.easeOut,
  }, '=-0.3');

  allTweens.push(tweenTeam);

  let sceneTeam = new ScrollMagic.Scene({
    triggerElement: '#meet-team',
    offset: calculateOffset(200),
    duration: 0,
    triggerHook: 'onEnter',
  }) //.addIndicators({name: "team"})
  .setTween(tweenTeam);

  sceneTeam.on('start', e => {
    if (e.scrollDirection !== 'REVERSE') {
      $(window).trigger('slider-stop');
    }
  });

  sceneTeam.enabled(false);
  sceneTeam.addTo(controller);
  globalScene.push(sceneTeam);
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/scenes/teamScene.js